import {BaseEntity} from "./BaseEntity";

export class Alarm implements BaseEntity {
    constructor(public id?: number,
                public alarmTime?: string,
                public rfidTag?: string,
                public readerName?: string,
                public readerLocation?: string,
                public assetName?: string,
                public assetDescription?: string,
                public alertingActionName?: string,
                public eventType?: string,
                public thresholdType?: string,
                public eventDetails?: string,
                public antennaNumber?: string,
                public rSSI?: string,
                public popupRequested?: boolean,
                public lastModifiedBy?:string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.alarmTime = json.alarmTime;// == null ? "" :  moment(json.alarmTime).format(entities.ApplicationSetting.applicationSetting.dateFormat);
        this.rfidTag = json.rfidTag;
        this.readerName = json.readerName;
        this.readerLocation = json.readerLocation;
        this.assetName = json.assetName;
        this.assetDescription = json.assetDescription;
        this.alertingActionName = json.alertingActionName;
        this.eventType = json.eventType;
        this.thresholdType = json.thresholdType;
        this.eventDetails = json.eventDetails;
        this.antennaNumber = json.antennaNumber;
        this.rSSI = json.rSSI;
        this.popupRequested = json.popupRequested;
        this.lastModifiedBy = json.lastModifiedBy;
    }
}
